<template>
  <el-dialog
    title="开票"
    :visible.sync="dialogVisible"
    width="600px"
    top="5vh"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="invoice-dialog-content">
      <div class="type-row">
        <div class="type-label">抬头类型</div>
        <div class="type-options">
          <el-radio-group v-model="invoiceType">
            <el-radio label="enterprise">企业</el-radio>
            <el-radio label="personal">个人/非企业</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div v-if="invoiceType === 'enterprise'" class="type-row">
        <div class="type-label">发票类型</div>
        <div class="type-options">
          <el-radio-group v-model="invoiceTypeCode">
            <el-radio label="01">数电增值税专用发票</el-radio>
            <el-radio label="02">数电普通发票</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="section-card">
        <div class="section-title">必填信息</div>

        <div class="field-row field-row--with-hint">
          <div class="field-label required">发票抬头</div>
          <div class="field-input-col">
            <el-input
              v-model.trim="form.buyerName"
              class="field-input"
              :placeholder="buyerNamePlaceholder"
              clearable
            />
            <div class="field-hint">{{ buyerNameHint }}</div>
          </div>
        </div>

        <div v-if="invoiceType === 'enterprise'" class="field-row">
          <div class="field-label required">纳税人识别号（税号）</div>
          <div class="field-input-col">
            <el-input
              v-model.trim="form.buyerTaxNo"
              class="field-input"
              placeholder="纳税人识别号"
              clearable
            />
          </div>
        </div>

        <div v-if="invoiceType === 'enterprise'" class="field-row">
          <div class="field-label required">接收邮箱</div>
          <div class="field-input-col">
            <el-input
              v-model.trim="form.pushEmail"
              class="field-input"
              placeholder="接收发票的邮箱"
              clearable
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-label required">接收手机</div>
          <div class="field-input-col">
            <el-input
              v-model.trim="form.buyerTelphone"
              class="field-input"
              placeholder="接收发票的手机号"
              clearable
            />
          </div>
        </div>
      </div>

      <div class="section-card">
        <div class="section-title">选填信息</div>

        <div class="field-row">
          <div class="field-label">开户银行</div>
          <div class="field-input-col">
            <el-input
              v-model.trim="form.buyerBankName"
              class="field-input"
              :placeholder="
                invoiceType === 'enterprise'
                  ? '企业对公银行网点'
                  : '请填写银行网点'
              "
              clearable
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-label">开户账号</div>
          <div class="field-input-col">
            <el-input
              v-model.trim="form.buyerBankNumber"
              class="field-input"
              :placeholder="
                invoiceType === 'enterprise'
                  ? '企业对公银行账号'
                  : '请填写银行账号'
              "
              clearable
            />
          </div>
        </div>
      </div>

      <div class="section-card">
        <div class="section-title">商品信息</div>

        <div
          class="goods-group"
          v-for="(detailItem, index) in form.invoiceDetailList"
          :key="index"
        >
          <div class="goods-row">
            <div class="goods-label">商品{{ index + 1 }}</div>
          </div>

          <div class="field-row">
            <div class="field-label">规格型号</div>
            <div class="field-input-col">
              <el-input
                class="field-input"
                :value="detailItem.goodsSpecification || '默认携带'"
                readonly
              />
            </div>
          </div>

          <div class="field-row">
            <div class="field-label">金额</div>
            <div class="field-input-col">
              <el-input
                class="field-input"
                :value="detailItem.goodsTotalPrice || '默认携带'"
                readonly
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="invoice-dialog-footer">
      <el-button class="cancel-btn" @click="handleClose">取消</el-button>
      <el-button class="confirm-btn" type="primary" @click="handleConfirm"
        >确认无误</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "InvoiceDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      invoiceType: "enterprise",
      invoiceTypeCode: "02",
      form: {
        buyerName: "",
        buyerTaxNo: "",
        buyerAddress: "",
        buyerTelphone: "",
        buyerBankName: "",
        buyerBankNumber: "",
        invoiceDetailList: [],
        remarks: "",
        pushEmail: "",
      },
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.initForm();
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
    // 切换抬头类型时，发票类型默认回到普票（个人只能开普票）
    invoiceType() {
      this.invoiceTypeCode = "02";
    },
  },
  computed: {
    buyerNamePlaceholder() {
      return this.invoiceType === "enterprise"
        ? "企业开票公司全称"
        : "必须填写真实姓名";
    },
    /** 与 placeholder 同义的小字说明，显示在输入框下方 */
    buyerNameHint() {
      return this.invoiceType === "enterprise"
        ? "开票公司全称"
        : "需为真实姓名";
    },
  },
  methods: {
    initForm() {
      // 初始化表单数据（对齐小程序：打开弹窗时默认企业）
      const item = this.orderItem;
      this.invoiceType = "enterprise";
      this.invoiceTypeCode = "02";
      this.form = {
        buyerName: item.customer || "",
        buyerTaxNo: "",
        buyerAddress: item.sendAddress || "",
        buyerTelphone: item.phone || "",
        buyerBankName: "",
        buyerBankNumber: "",
        invoiceDetailList: [],
        remarks: item.desc || "",
        pushEmail: "",
      };

      // 初始化商品信息（用于展示，只读）
      if (item.details && item.details.length) {
        this.form.invoiceDetailList = item.details.map((detailItem) => {
          return {
            goodsName: "维修费",
            goodsSpecification: detailItem.model || "",
            goodsTotalPrice: detailItem.repair?.bill?.amount || "0",
            goodsQuantity: "1",
            goodsTaxRate: "0.13",
            goodsPrice: detailItem.repair?.bill?.amount || "0",
          };
        });
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit("close");
    },
    validateForm() {
      if (!this.form.buyerName) {
        this.elMsg(
          this.invoiceType === "enterprise"
            ? "请输入企业抬头"
            : "请输入真实姓名",
          "warning"
        );
        return false;
      }

      if (!this.form.buyerTelphone) {
        this.elMsg("请输入接收手机号", "warning");
        return false;
      }

      if (this.invoiceType === "enterprise") {
        if (!this.form.buyerTaxNo) {
          this.elMsg("请输入纳税人识别号（税号）", "warning");
          return false;
        }
        if (!this.form.pushEmail) {
          this.elMsg("请输入接收邮箱", "warning");
          return false;
        }
      }

      return true;
    },
    handleConfirm() {
      if (!this.validateForm()) return;

      // 小程序端 buyerAddress 传空，这里保持一致
      const payload = {
        ...this.form,
        buyerAddress: "",
        naturalMark: this.invoiceType === "enterprise" ? "0" : "1",
        invoiceTypeCode: this.invoiceTypeCode,
      };

      this.$emit("confirm", payload);
      this.handleClose();
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}

.form-item-tip {
  font-size: 12px;
  color: #909399;
}

.goods-item {
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }

  .goods-item-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 15px;
  }
}

.dialog-footer {
  text-align: right;
  display: block;
}

::v-deep .el-collapse-item__header {
  font-weight: bold;
  color: #ce643d;
}

::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 12px;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0;
}
.type-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-left: 16px;
}

.type-label {
  width: 160px;
  font-size: 14px;
  color: #333;
  font-weight: 600;
  padding-right: 10px;
}

.type-options {
  flex: 1;
}

.section-card {
  background: #fff;
  padding: 0 16px;
  border-radius: 4px;
}

.section-title {
  padding: 16px 0 10px;
  color: #e67e22;
  font-size: 15px;
  font-weight: 600;
}

.field-row {
  border-top: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 12px 0;
}

.field-row--with-hint {
  align-items: flex-start;
}

.field-row--with-hint .field-label {
  margin-top: 6px;
}

.field-label {
  min-width: 180px;
  font-size: 14px;
  color: #303133;
  font-weight: 600;
  flex-shrink: 0;
}

.field-label.required::after {
  content: "*";
  color: #f56c6c;
  margin-left: 6px;
}

.field-input-col {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-input {
  ::v-deep input[readonly] {
    border: none;
  }
}

.field-hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.45;
}

::v-deep .el-input__inner {
  height: 34px;
}

.goods-group {
  &:last-child {
    margin-bottom: 0;
  }
}

.goods-row {
  border-top: 0;
  padding: 2px 0 0;
}

.goods-label {
  font-size: 14px;
  color: #303133;
  font-weight: 600;
  line-height: 40px;
}

.invoice-dialog-footer {
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn {
  border: 1px solid #dcdfe6;
  color: #303133;
  background: #fff;
}

.confirm-btn {
  background: #eb7a2f !important;
  border-color: #eb7a2f !important;
  color: #fff !important;
}
</style>
